// Tool to base64 encode other images as needed: https://elmah.io/tools/base64-image-encoder/ , alternatively try `cat <file_dir> | base64`.
// Icons are encoded to prevent blocked requests from CORS across environments
// Jest throws an error if I do a straight `export * as`
import abSplitI from './abSplit';
import addContactI from './addContact';
import ai from './ai';
import attributeSplitI from './attributeSplit';
import callWebhookI from './callWebhook';
import changeContactFieldI from './changeContactField';
import channelOptI from './channelOpt';
import contactActionI from './contactAction';
import delayI from './delay';
import deleteI from './delete';
import fbAudienceI from './fbAudience';
import fieldsMatchI from './fieldsMatch';
import holdI from './hold';
import holdUntilReplyI from './holdUntilReply';
import modifyChannelI from './modifyChannel';
import noteI from './note';
import quietI from './quietHours';
import removeContactI from './removeContact';
import sendEmailDarkI from './sendEmailDark';
import sendEmailI from './sendEmail';
import sendEmbeddedI from './sendEmbedded';
import sendInAppI from './sendInApp';
import sendPushDarkI from './sendPushDark';
import sendPushI from './sendPush';
import sendSMSDarkI from './sendSMSDark';
import sendSMSI from './sendSMS';
import sendWebPushI from './sendWebPush';
import sendWhatsAppI from './sendWhatsApp';
import startI from './start';
import subscriptionsI from './subscriptions';
import triggerWorkflowI from './triggerWorkflow';
import userI from './user';
import usersEnteredI from './usersEntered';
import usersExitedI from './usersExited';
import warningI from './warning';

export const abSplitIcon = abSplitI;
export const addContactIcon = addContactI;
export const aiIcon = ai;
export const attributeSplitIcon = attributeSplitI;
export const callWebhookIcon = callWebhookI;
export const changeContactFieldIcon = changeContactFieldI;
export const channelOptIcon = channelOptI;
export const contactActionIcon = contactActionI;
export const delayIcon = delayI;
export const deleteIcon = deleteI;
export const fbAudienceIcon = fbAudienceI;
export const fieldsMatchIcon = fieldsMatchI;
export const holdIcon = holdI;
export const holdUntilReplyIcon = holdUntilReplyI;
export const modifyChannelIcon = modifyChannelI;
export const noteIcon = noteI;
export const quietHoursIcon = quietI;
export const removeContactIcon = removeContactI;
export const sendEmailDarkIcon = sendEmailDarkI;
export const sendEmailIcon = sendEmailI;
export const sendEmbeddedIcon = sendEmbeddedI;
export const sendInAppIcon = sendInAppI;
export const sendPushDarkIcon = sendPushDarkI;
export const sendPushIcon = sendPushI;
export const sendSMSDarkIcon = sendSMSDarkI;
export const sendSMSIcon = sendSMSI;
export const sendWebPushIcon = sendWebPushI;
export const sendWhatsAppIcon = sendWhatsAppI;
export const startIcon = startI;
export const subscriptionsIcon = subscriptionsI;
export const triggerWorkflowIcon = triggerWorkflowI;
export const userIcon = userI;
export const usersEnteredIcon = usersEnteredI;
export const usersExitedIcon = usersExitedI;
export const warningIcon = warningI;

const icons = {
  abSplitIcon,
  addContactIcon,
  aiIcon,
  attributeSplitIcon,
  callWebhookIcon,
  changeContactFieldIcon,
  channelOptIcon,
  contactActionIcon,
  delayIcon,
  deleteIcon,
  fbAudienceIcon,
  fieldsMatchIcon,
  holdIcon,
  modifyChannelIcon,
  noteIcon,
  quietHoursIcon,
  removeContactIcon,
  sendEmailIcon,
  sendPushIcon,
  sendSMSIcon,
  sendWebPushIcon,
  sendWhatsAppIcon,
  startIcon,
  subscriptionsIcon,
  triggerWorkflowIcon,
  userIcon,
  usersEnteredIcon,
  usersExitedIcon,
  warningIcon,
};

export default icons;
